import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=e8b30964&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b30964",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8b30964')) {
      api.createRecord('e8b30964', component.options)
    } else {
      api.reload('e8b30964', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=e8b30964&scoped=true&", function () {
      api.rerender('e8b30964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28e3WUjVL6GD6/JS/comp/SearchFilterTokens.vue"
export default component.exports